import { Injectable } from '@angular/core';
import {
	VehicleInsuranceListDto,
	VehicleInsuranceRecordDto,
	VehicleInsurancesAppOptionsDto,
	VehicleInsurancesFilters,
	VehicleInsurancesStatsDto,
	VehicleInsuranceSearchDto,
	CreateVehicleInsuranceDto,
	UpdateVehicleInsuranceDto,
} from '@splitsecondconnect/ultramarine-shared';

import { BaseRecordResolver } from '../../../../shared/base-classes/base-record.resolver';
import { VehicleInsurancesService } from '../vehicle-insurances.service';

@Injectable({
	providedIn: 'root',
})
export class VehicleInsurancesRecordResolver extends BaseRecordResolver<
	VehicleInsuranceRecordDto,
	CreateVehicleInsuranceDto,
	UpdateVehicleInsuranceDto,
	VehicleInsuranceListDto,
	VehicleInsurancesStatsDto,
	VehicleInsurancesAppOptionsDto,
	VehicleInsurancesFilters,
	VehicleInsuranceSearchDto
> {
	constructor(private _vehicleInsurancesService: VehicleInsurancesService) {
		super(_vehicleInsurancesService);
	}
}
